import React, { useRef, useState } from "react";
import "./AudioPlayer.css";

const AudioPlayer = ({ song }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  if (!song) return null;

  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <div className="audio-player">
      <p>{song.title}</p>
      <audio
        ref={audioRef}
        controls
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}

        preload="none"
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      >
        <source
          src={`https://gigabout.com.au/audio/${song.id}`}
          type="audio/mpeg"
        />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};

export default AudioPlayer;
